import React, { useEffect } from 'react';
import './index.css';
import { Outlet, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const dashboardTypes = [
  {
    value: 1,
    label: 'Керівник',
  },
  {
    value: 2,
    label: 'Керівник відділу',
  },
  {
    value: 3,
    label: 'Співробітник',
  },
];

export default function DashboardPage() {
  // get current path from useLocation hook
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split('/')[2];
  console.log(path);
  const [dashboardType, setDashboardType] = React.useState<number>(null); 
  
  useEffect(() => {
    console.log(path);
    switch (path) {
      case 'manager':
        setDashboardType(1);
        break;
      case 'head_of_department':
        setDashboardType(2);
        break;
      case 'employee':
        console.log('yo');
        setDashboardType(3);
        break;
      default:
        break;
    }
  }, [path]);

  const nextPath = () => {
    switch (path) {
      case 'manager':
        return 'head_of_department';
      case 'head_of_department':
        return 'employee';
      case 'employee':
        return 'manager';
      default:
        return 'manager';
    }
  };


  return (
    <div className="dashboard-section">
      <div className='dashboard-top-line'>
        <h2 className='new-h2 add-user-title'>Панель управління</h2>
        <div className='dashboard-type-wrapper'>
          <p>Тип панелі управління:</p>
          <p onClick={()=>{navigate(nextPath());}} className='dashboard-type-link basic-link'>{dashboardType && dashboardTypes[dashboardType - 1]?.label}</p>
        </div>
      </div>
      <Outlet />
    </div>
  );
}